<template>
  <div
    class="boss-table-2-layout"
    data-test="work-style-area"
  >
    <scout-form
      label="志向の指定"
      has-child
    >
      <div
        class="boss-table-2-item boss-table-2-item-body"
        :class="[{ 'is-modified': isModified }]"
      >
        <div class="boss-layout boss-layout-start boss-layout-gap-large">
          <label
            v-for="(option, i) in options"
            :key="i"
            :data-test="`label-${i}`"
            class="pega-input"
          >
            <input
              :checked="selectedOption === option.key"
              :value="option.key"
              :data-test="`radio-${i}`"
              class="boss-input-checkbox"
              type="radio"
              @change="$emit('update:selectedOption', $event.target.value)"
            >{{ option.label }}
          </label>
          <span class="boss-annotation-text">
            ※スライドバーを動かしてご利用ください
          </span>
        </div>
      </div>
      <scout-form-work-style-item
        v-for="(workStyle,i) in workStylesData"
        :key="i"
        :volition="workStyle.volition"
        :name="workStyle.name"
        :left-label="workStyle.firstLabel"
        :right-label="workStyle.lastLabel"
        :data-test="`item-${workStyle.id}`"
        @update:volition="update($event, workStyle.id)"
      />
    </scout-form>
  </div>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import ScoutFormWorkStyleItem from '@/components/atoms/ScoutFormWorkStyleItem'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ScoutForm,
    ScoutFormWorkStyleItem
  },
  props: {
    workStyles: {
      required: true,
      type: Array
    },
    selectedOption: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      isOpen: !!this.workStyles.length,
      options: [
        { key: 'and', label: 'すべてを含む' },
        { key: 'or', label: 'いずれかを含む' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'workStylesMaster'
    ]),
    workStylesData () {
      return this.workStylesMaster.map(workStyleMaster => {
        const workStyleData = this.workStyles.find(workStyle => workStyle.id === workStyleMaster.id)
        return {
          ...workStyleMaster,
          volition: (workStyleData && workStyleData.answer) ? [workStyleData.answer.minimum, workStyleData.answer.maximum] : null
        }
      })
    },
    isModified () {
      return this.workStyles.some(workStyle => !_.isEmpty(_.get(workStyle, 'answer')))
    }
  },
  methods: {
    update (answers, id) {
      const updateWorkStyleIndex = this.workStyles.findIndex(workStyle => workStyle.id === id)
      if (updateWorkStyleIndex !== -1) {
        const updateWorkStyles = [...this.workStyles]
        updateWorkStyles.splice(updateWorkStyleIndex, 1, { id: id, answer: answers })
        this.$emit('update:workStyles', updateWorkStyles)
      } else {
        // idの昇順にする
        this.$emit('update:workStyles', _.sortBy([...this.workStyles, { id: id, answer: answers }], ['id']))
      }
    }
  }
}
</script>
